import { CommonSmallVerticalArrowIcon } from '@local/assets/icons'

import Clickable from '@web/ui/components/Clickable'
import { Section, SectionHeader, SectionContent } from '@web/ui/pages/home/components/Sections/Section'
import { UpcomingSectionItemType } from '@web/ui/pages/home/components/Sections/UIUpComingSection'
import BookingCardItem from '@web/ui/pages/home/components/Sections/UIUpComingSection/components/BookingCardItem'
import OrderCardItem from '@web/ui/pages/home/components/Sections/UIUpComingSection/components/OrderCardItem'
import TicketCardItem from '@web/ui/pages/home/components/Sections/UIUpComingSection/components/TicketCardItem'

import styles from './UpcomingSection.module.scss'

interface Props {
  title: string
  upcomingItems: UpcomingSectionItemType[]
  upcomingItemCount: number
  hasMore?: boolean
  onClickMore?: () => void
}

export default function UITimelinePaginationUpcomingSection({
  title,
  upcomingItems,
  upcomingItemCount,
  hasMore,
  onClickMore,
}: Props) {
  return (
    <>
      <Section className={styles.upcoming_section} noMargin>
        <SectionHeader title={title} count={upcomingItemCount} />
        <SectionContent>
          <ul className={styles.upcoming_list}>
            {upcomingItems.map((upcomingItem, index) => {
              const isLastIndex = index == upcomingItems.length - 1
              // 접근성 대비
              const ariaHidden = isLastIndex && hasMore

              if (upcomingItem.type === 'order') {
                return <OrderCardItem key={upcomingItem.id} item={upcomingItem} ariaHidden={ariaHidden} />
              }

              if (upcomingItem.type === 'booking') {
                return <BookingCardItem key={upcomingItem.id} item={upcomingItem} ariaHidden={ariaHidden} />
              }

              if (upcomingItem.type === 'ticket') {
                return <TicketCardItem key={upcomingItem.id} item={upcomingItem} ariaHidden={ariaHidden} />
              }

              return null
            })}

            {/* 접근성 처리 */}
            {/* 더보기 버튼의 그라데이션이 겹쳐 있어서 온전히 보이지 않는 카드는 포커스 이동에서 건너뛰고 더보기로 가야 합니다. (이 때 카드에 aria-hidden 처리하면 될것 같고)
          더보기 클릭 후에 온전히 보여지게 된 카드로 포커스 이동해야합니다. (이 때 카드에 aria-hidden false하면 됩니다) */}
            {hasMore && (
              <li className={styles.list_item}>
                <div className={styles.list_item_inner}>
                  <Clickable className={styles.btn_more} onClick={onClickMore}>
                    펼쳐서 더보기
                    <CommonSmallVerticalArrowIcon className={styles.icon_arrow} />
                  </Clickable>
                </div>
              </li>
            )}
          </ul>
        </SectionContent>
      </Section>
    </>
  )
}
